export type PostShiftMethod = (typeof POST_METHODS)[keyof typeof POST_METHODS];

export const POST_METHODS = {
  SINGLE: "single",
  SCHEDULE: "schedule",
  ASSIGN: "assign",
  EVENT: "event",
} as const;
export const postShiftMethods = Object.values(POST_METHODS);
export const multipleStepsMethods: ReadonlyArray<PostShiftMethod> = [POST_METHODS.SCHEDULE, POST_METHODS.EVENT];

export const postGigTypeLabelLookup: Record<PostShiftMethod, string> = {
  single: "Post Shift",
  schedule: "Post Schedule",
  assign: "Assign Shift",
  event: "Create Event",
};
